export const SIGN_UP_CTA_CLICK = 'Sign Up CTA Click';
export const GET_LOOM_CTA_CLICK = 'Get Loom CTA Click';
export const OAUTH_BUTTON_CLICKED = 'Sign Up/In Oauth Button Clicked';
export const EMAIL_LOGIN_BUTTON_CLICKED = 'Email Login Button Clicked';
export const EMAIL_LOGIN_FAILED = 'Email Login Failed';
export const CONTINUE_WITH_SSO_BUTTON_CLICKED =
  'Continue with SSO Button Clicked';
export const EMAIL_SIGNUP_FORM_TOGGLED = 'Email Sign Up Form Toggled';
export const EMAIL_SIGNUP_BUTTON_CLICKED = 'Email Sign Up Button Clicked';
export const EMAIL_SIGNUP_FAILED = 'Email Sign Up Failed';
export const LOGIN_FORM_VIEWED = 'Login Form Viewed';
export const SIGNUP_PAGE_MODE_TOGGLED = 'Signup Page Mode Toggled';
export const FORGOT_PASSWORD_CLICKED = 'Forgot Password Clicked';
export const UPLOAD_CSV_CLICKED = 'Upload CSV clicked';

// Sign up
export const SIGNUP_CLICKED_TERMS = 'Signup Page Terms of Service Click';
export const SIGNUP_CLICKED_PRIVACY = 'Signup Page Privacy Policy Click';
export const SIGNUP_TOGGLE_TERMS_CHECKBOX = 'Signup Toggle Terms Checkbox';
export const SIGNUP_EMAIL_FIELD_CLICKED = 'Signup Email Field Clicked';

export const PAGE_RESET_PASSWORD = 'Reset Password';
export const PAGE_CHANGE_PASSWORD = 'Change Password';

// video player
export const VIDEO_PLAYER_STEP = 'Video Player Step Change';

// destination video recommendations
export const VIDEO_SUGGESTION_SHOWN = 'video_suggestion_shown';

// Share video page
export const SHARE_VIDEO_EXTENSION_MODAL_CLICK =
  'Share Video Extension Modal Click';
export const SHARE_MENU_ACTION_OPEN_MENU = 'Share Menu Opened';
export const SHARE_MENU_ACTION_LINK = 'Share Menu Link Copied';
export const SHARE_MENU_ACTION_EMBED = 'Share Menu Embed Code Copied';
export const SHARE_MENU_ACTION_FB_SHARE = 'Share Menu Facebook Link Clicked';
export const SHARE_MENU_ACTION_TW_SHARE = 'Share Menu Twitter Link Clicked';
export const SHARE_MENU_ACTION_GM_SHARE = 'Share Menu Gmail Link Clicked';
export const SHARE_CTA_ACTION_LINK = 'Share CTA Copy Link Click';
export const SHARE_VIDEO_SETTINGS_UPDATED = 'Share Video Settings Updated';
export const USER_CHANGED_NOISE_SUPPRESSION =
  'User Changed BG Noise Suppression';
export const VIDEO_START_NOISE_SUPPRESSION = 'Video Start Noise Suppression';
export const SHARE_VIDEO_PRIVACY_UPDATED = 'Share Video Privacy Updated';
export const SHARE_MENU_ACTION_EMBED_THUMB =
  'Share Menu Embed Thumbnail Copied';
export const SHARE_MENU_ACTION_EMBED_THUMB_HTML =
  'Share Menu Embed Thumbnail HTML Copied';
export const SHARE_MENU_ACTION_EMBED_THUMB_LINK =
  'Share Embed Thumbnail Link Clicked';
export const THEATER_MODE_TOGGLED = 'Theater Mode Toggled';
export const CLICKED_ANDROID_DOWNLOAD_APP =
  'Clicked Download App on Android Mobile Web';
export const CLICKED_IOS_SHARE_DOWNLOAD_APP =
  'Clicked Download App on iOS Mobile Web';
export const SHARE_VIDEO_NAME_UPDATED = 'Video name updated';
export const SHARE_VIDEO_DESCRIPTION_UPDATED = 'Video description updated';
export const SHARE_VIDEO_DESCRIPTION_TIMESTAMP_CLICKED =
  'Description timestamp clicked';
export const SHARE_PAGE_RECORD_REPLY_BUTTON_CLICKED =
  'Share page record reply button clicked';
export const SHARE_PAGE_PAUSE_BUTTON_CLICKED =
  'Share page pause button clicked';
export const SHARE_PAGE_END_SCREEN_VIEWED = 'Share page end screen viewed';

// Anon record a reply
export const ANON_COMMENT_BUTTON_CLICKED = 'Anon comment button click';
export const EXIT_ANON_RECORD_A_REPLY_SIGNUP_MODAL =
  'Exit anon record a reply signup modal';

export const EXIT_ANON_CREATOR_SIGNUP_MODAL = 'Exit anon create signup modal';

// Share screenshot page
export const SHARE_SCREENSHOT_DELETED = 'Share Screenshot Creator Deleted';
export const SHARE_SCREENSHOT_VIEWED = 'Share Screenshot Viewed';
export const SHARE_SCREENSHOT_DOWNLOADED = 'Share Screenshot Downloaded';
export const SHARE_SCREENSHOT_ZOOM_IN = 'Share Screenshot Zoomed In';
export const SHARE_SCREENSHOT_ZOOM_OUT = 'Share Screenshot Zoomed Out';

// editor actions
export const SHARE_PAGE_EDITOR_FAB_PRO_UPSELL =
  'Share Page Editor FAB Pro Upsell';

// video download clicked
export const VIDEO_DOWNLOAD_CLICK = 'Video Download Click';
export const VIDEO_DOWNLOAD_COMPLETED = 'Video Download Completed';

// duplicate
export const DUPLICATE_ITEM_CLICK = 'Duplicate Item Click';

// comments
export const VIDEO_DESCRIPTION_ADD_LINK_CLICK =
  'Video Description Link Add Click';
export const VIDEO_COMMENT_CREATED = 'Video Comment Created';
export const VIDEO_COMMENT_REPLY_CREATED = 'Video Comment Reply Created';

export const VIDEO_PLAYER_ENTER_COMMENT_MODE =
  'Video Player Entered Comment Mode';
export const VIDEO_PLAYER_SHOW_ALL_COMMENTS = 'Video Player Show All Comments';

// account settings analytics
export const ACCOUNT_SETTINGS_OAUTH_CLICKED = 'Account Settings Oauth Clicked';
export const ACCOUNT_SETTINGS_OAUTH_REMOVED = 'Account Settings OAuth Removed';
export const BRAND_SHOW_BRANDING_TOGGLED = 'Brand Show Branding Toggled';
// embed video player
export const EMBED_WATCH_ON_LOOM_CLICK = 'Embed Watch on Loom Click';
export const EMBED_TITLE_CLICK = 'Embed Title Click';
export const EMBED_OWNER_INFO_CLICK = 'Embed Owner Info Click';
export const WATCH_AGAIN_CLICK = 'Watch Again Click';
export const FULL_SCREEN_CLICK = 'Full Screen Click';
export const START_SCREEN_SPEED_SELECTOR_CLICK =
  'Start Screen Speed Selector Click';
export const VIDEO_PLAYER_VIDEO_PLAY_START = 'Video Player Video Play Start';
export const VIDEO_PLAYER_VIDEO_PAUSE = 'Video Player Video Pause';
export const PLAYBACK_RATE_CHANGE = 'Playback Rate Change';
export const EMBED_LOGGED_OUT_SCREEN_VIEWED = 'Embed Logged Out Screen Viewed';
export const EMBED_NOT_IN_EMAIL_SCREEN_VIEWED =
  'Embed Not In Email Screen Viewed';
export const EMBED_NEED_EMAIL_VERIFICATION_SCREEN_VIEWED =
  'Embed Need Email Verification Screen Viewed';
export const EMBED_END_SCREEN_VIEWED = 'Embed End Screen Viewed';
export const EMBED_PAUSE_SCREEN_VIEWED = 'Embed Pause Screen Viewed';

// trigger analytics
export const NEW_ONBOARDING_EXISTING_USER_COMPLETE =
  'New Onboarding Existing User Trigger';

// organization analytics
export const BULK_MOVED = 'Bulk Moved';
export const FOLDER_FAVORITED = 'Folder Favorited';
export const FOLDER_MOVED = 'Folder Moved';
export const FOLDER_ARCHIVED = 'Folder Archived';

export const VIDEO_ARCHIVED = 'Video Archived';
export const VIDEO_MOVED = 'Video Moved';
export const VIDEO_RESTORED = 'Video Restored';
export const VIDEO_FAVORITED = 'Video Favorited';

// persona onboarding
export const CLICKED_JTBD_FOLDER = 'Clicked JTBD Folder';
export const CLICKED_WELCOME_LOOM = 'Clicked Welcome Loom';
export const WELCOME_LOOM_SHOW_ALL_TOGGLED = 'Welcome Loom Show All Toggled';
export const WELCOME_LOOM_SCROLL_NEXT_CLICKED =
  'Welcome Loom Scroll Next Clicked';
export const WELCOME_LOOM_SCROLL_PREVIOUS_CLICKED =
  'Welcome Loom Scroll Previous Clicked';
export const COMPLETED_PERSONA_V1_STEP_ONE_POINT_FIVE =
  'Completed Persona V1 Step One Point Five';
// Slack Identity links
export const ONBOARDING_INTRO_MODAL_VIEWED =
  'Onboarding Introduction Modal Viewed';
export const ONBOARDING_INTRO_MODAL_CLICKED =
  'Onboarding Introduction Modal Clicked';
export const VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_VIEWED =
  'Video Share Page Onboarding Modal Viewed';
export const VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_CLICKED =
  'Video Share Page Onboarding Modal Clicked';
export const VIDEO_SHARE_PAGE_ONBOARDING_NUDGE_MODAL_DISMISSED =
  'Video Share Page Onboarding Modal Dismissed';

// newest onboarding events
export const ONBOARDING_FLOW_STARTED = 'Onboarding Flow Started'; // first screen of onboarding flow loaded
export const ONBOARDING_FLOW_FINALIZED = 'Onboarding Flow Finalized'; // complete onboarding path finalized
export const COMPLETED_ONBOARDING_STEP = 'Complete Onboarding Step'; // generic step tracking
export const ONBOARDING_FLOW_COMPLETE = 'Onboarding Flow Complete'; // onboarding flow completed
export const ONBOARDING_DOWNLOAD_RECORDER_SCREEN_VIEWED =
  'Onboarding download recorder screen viewed';
export const USER_WORK_PERSONA_SELECTED = 'User Work Persona Selected';

// dashboard onboarding events
export const DASHBOARDING_ONBOARDING_LOADED = 'Dashboard Onboarding Loaded';
export const DASHBOARDING_ONBOARDING_CARD_VISIBLE =
  'Dashboard Onboarding Card Visible';
export const DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED =
  'Dashboard Onboarding Card CTA Clicked';
export const DASHBOARDING_SIDEBAR_UPSELL_BUTTON_CLICKED =
  'Dashboard Onboarding Sidebar Upsell Button Clicked';
export const DASHBOARDING_ONBOARDING_STARRED_CTA_CLICKED =
  'Dashboard Onboarding Starred CTA Clicked';

// Welcome page
export const EXT_TOOLTIP_VIEWED = 'Activate extension tooltip viewed';

// push notifications onboarding
export const PUSH_NOTIFICATION_PROMPT_SHOWN = 'Push Notification Prompt Shown';
export const PUSH_NOTIFICATION_PROMPT_ACCEPTED =
  'Push Notification Prompt Accepted';
export const PUSH_NOTIFICATION_PROMPT_DISMISSED =
  'Push Notification Prompt Dismissed';
export const PUSH_NOTIFICATION_GET_STARTED_CLICK =
  'Push Notification Get Started Checklist Item Click';
export const DEVICE_BROWSER_NOT_PUSHABLE =
  'Push Notification Not Supported On Device';

// web app notifs
export const WEB_APP_NOTIF_DRAWER_OPEN = 'Web App Notifications Drawer Open';
export const WEB_APP_NOTIF_NOTIFICATION_CLICK =
  'Web App Notifications Notification Click';

// use cases page
export const SELECTED_USE_CASE = 'Selected Use Case';
// videos Playlist
export const PLAYLIST_VIDEO_PLAYED = 'Playlist Video Played';

// extension install
export const EXTENSION_INSTALL_CLICKED = 'Extension Install Button Clicked';
// emoji reactions
export const EMOJI_REACTION_CREATED = 'Emoji Reaction';
export const EMOJI_REACTION_DELETED = 'Emoji Deleted';
export const EMOJI_REACTION_CLICKED = 'Emoji Clicked';

// trimming
export const ENTERED_TRIM_MODE = 'Entered Trim Mode';
export const TRIM_PUBLISHED = 'Trim Published';
export const TRIM_CHANGE_MADE = 'Trim Change Made';
export const TRIM_REVERT_TO_ORIGINAL = `Trimming Click Revert to original`;
export const TRIM_DELETE = 'Trimming click delete';
export const TRIM_CANCELLED = 'Trim changes cancelled';
export const TRIM_HELP_ARTICLE_CLICKED = 'Trim help article clicked';
export const SHARE_FOLDER_NEW_PUBLIC_FOLDER_CLICKED =
  'New Public Folder Clicked';
export const SHARE_FOLDER_COPY_LINK_CLICKED = 'Share Folder Copy Link Clicked';
export const SHARE_FOLDER_PAGE_VIEWED = 'Viewed Public Folder Page';
export const SHARE_FOLDER_FOLDER_CLICKED = 'Public Folder: Clicked Folder Card';
export const SHARE_FOLDER_VIDEO_CLICKED = 'Public Folder: Clicked Video Card';

// avatars
export const ACCOUNT_SETTINGS_PROFILE_PHOTO_SET =
  'Account Settings Profile Photo Set';

export const CUSTOM_THUMBNAIL_CLICKED = 'Video Custom Thumbnail Clicked';
export const HEADER_NAV_LINK_CLICKED = 'Header Nav Link Clicked';

// End of Video CTA events
export const ADD_CUSTOM_VIDEO_CTA_CLICKED = 'Add Custom Video CTA Clicked';
export const ADD_CUSTOM_VIDEO_CTA_ENABLED = 'Add Custom Video CTA Enabled';
export const REMOVE_CUSTOM_VIDEO_CTA_CLICKED = 'Remove Custom Video CTA';
export const VIDEO_CTA_CLICKED = 'Video CTA Clicked';
export const SHOW_VIDEO_PLAYER_END_SCREEN = 'Video Player End Screen Shown';

// custom viewer events
export const ADD_CUSTOM_VIEWERS_CTA_CLICKED = 'Add Custom Viewers CTA Clicked';
export const CUSTOM_VIEWERS_APPLIED = 'Custom Viewers Applied';

// Download Events
export const DOWNLOAD_DESKTOP_APP = 'Download Desktop App';
export const DOWNLOAD_PAGE_LEARN_MORE = 'Download Page Learn More Click';
export const DOWNLOAD_PAGE_MORE_OPTIONS = 'Download Page Options Expand';

export const DOWNLOAD_PAGE_DASHBOARD_CLICK = 'Dowload Page Dashboard Click';

// dashboard events
export const DASHBOARD_SCREENSHOT_DELETED = 'Dashboard Screenshot Deleted';
export const DASHBOARD_SCREENSHOT_DOWNLOADED =
  'Dashboard Screenshot Downloaded';
export const DASHBOARD_EMPTY_STATE_UPSELL_CLICK =
  'Dashboard Empty State Upsell Click';
export const CHROME_DASHBOARD_EXTENSION_NOT_INSTALLED_RECORD_BUTTON_CLICK =
  'Chrome Dashboard Extension Not Installed Record Button Clicked';
export const CHROME_DASHBOARD_EXTENSION_NOT_INSTALLED_MODAL_DISMISSED =
  'Chrome Dashboard Extension Not Installed Modal Dismissed';
export const CHROME_DASHBOARD_EXTENSION_NOT_INSTALLED_MODAL_GO_TO_STORE_CLICK =
  'Chrome Dashboard Extension Not Installed Modal Go To Store Click';
export const CHROME_DASHBOARD_EXTENSION_NOT_INSTALLED_MODAL_EXTENSION_HC_ARTICLE_CLICK =
  'Chrome Dashboard Extension Not Installed Modal Extension Help Article Click';
export const CHROME_DASHBOARD_EXTENSION_NOT_INSTALLED_MODAL_DESKTOP_HC_ARTICLE_CLICK =
  'Chrome Dashboard Extension Not Installed Modal Desktop Help Article Click';
export const NON_CHROME_DASHBOARD_HOW_TO_RECORD_TOOLTIP_VIEWED =
  'Non Chrome Dashboard How To Record Tooltip Viewed';
export const NON_CHROME_DASHBOARD_HOW_TO_RECORD_TOOLIP_EXTENSION_ARTICLE_CLICK =
  'Non Chrome Dashboard How To Record Tooltip Extension Article Click';
export const NON_CHROME_DASHBOARD_HOW_TO_RECORD_TOOLIP_DESKTOP_ARTICLE_CLICK =
  'Non Chrome Dashboard How To Record Tooltip Desktop Article Click';
export const VIDEO_UPLOADS_HOVER_ACCESS_DENIED =
  'Video Upload Button Hover Access Denied';
export const VIDEO_RECORD_HOVER_ACCESS_DENIED =
  'Video Record Button Hover Access Denied';
// Onboarding
export const ONBOARDING_MOBILE_EMAIL = 'Sent Onboarding Mobile Download Email';
// New onboarding
export const VIEWED_ONBOARDING_CARD = 'Viewed Onboarding Card';
export const DOWNLOAD_BUTTON_CLICKED = 'Download Loom Button Clicked';

// Billing and Account Management
export const START_FREE_TRIAL_CLICK = 'Start Free Trial Click';
// workspace L4T billing events
export const WORKSPACE_BILLING_CONTACT_US_MODAL_TOGGLED =
  'Workspace Billing Contact Us Modal Toggled';
export const WORKSPACE_BILLING_CANCEL_DOWNGRADE_MODAL_TOGGLED =
  'Workspace Billing Cancel Downgrade Modal Toggled';
export const WORKSPACE_BILLING_CHECKOUT_FLOW_TOGGLED =
  'Workspace Billing Checkout Flow Toggled';
export const WORKSPACE_BILLING_DOWNGRADE_FLOW_TOGGLED =
  'Workspace Billing Downgrade Flow Toggled';
export const WORKSPACE_BILLING_MANAGE_SUBSCRIPTION_TOGGLED =
  'Workspace Billing Manage Subscription Toggled';

export const WORKSPACE_BILLING_UPDATE_BILLING_CYCLE_CLICKED =
  'Workspace Billing Update Billing Cycle Clicked';
export const WORKSPACE_BILLING_HISTORY_DOWNLOAD_INVOICE =
  'Workspace Billing History Download Invoice';
export const WORKSPACE_BILLING_CONTACT_SUPPORT_LINK_CLICK =
  'Workspace Billing Contact Support Link Click';

export const WORKSPACE_BILLING_EDIT_PAYMENT_METHOD_TOGGLED =
  'Workspace Billing Edit Payment Method Toggled';
export const WORKSPACE_BILLING_PAYMENT_UPDATE_CLICKED =
  'Workspace Billing Payment Update Clicked';
export const WORKSPACE_BILLING_DOWNGRADE_STEP_HANDLER_CLICK =
  'Workspace Billing Downgrade Step Handler Click';
export const WORKSPACE_PLAN_AND_BILLING_SEE_ALL_FEATURES_CLICK =
  'Workspace Plan and Billing See All Features Click';

export const WORKSPACE_AUTO_DOWNGRADE_SPLASH_SEE_UPGRADE_OPTIONS_CLICK =
  'Workspace Auto Downgrade Splash "See Upgrade Options" Click';
export const WORKSPACE_AUTO_DOWNGRADE_SPLASH_REVIEW_CHANGES_CLICK =
  'Workspace Auto Downgrade Splash "Review Changes" Click';
export const WORKSPACE_AUTO_DOWNGRADE_CONSEQUENCES_SEE_UPGRADE_OPTIONS_CLICK =
  'Workspace Auto Downgrade Splash "See Upgrade Options" Click';
export const WORKSPACE_AUTO_DOWNGRADE_CONSEQUENCES_KEEP_LIMITED_FUNCTIONALITY_CLICK =
  'Workspace Auto Downgrade Splash "Keep Limited Functionality" Click';
export const WORKSPACE_INVITATION_CONFIRMATION_CONFIRM_CLICK =
  'Workspace Invitation Confirmation Confirm Click';

export const WORKSPACE_INVITATION_WRONG_ACCOUNT_SIGN_OUT =
  'Workspace Invitation Wrong Account Sign Out';

export const INVITE_TEAMMATES_EMAIL_INVITE_MODAL_ADD_CLICK =
  'Invite Team Members Email Invite Modal Add Click';

export const VIEWED_ACTIVITY_FEED = 'Viewed Activity Feed';
export const CLICKED_ACTIVITY_FEED_ACTIVITY = 'Clicked Activity Feed Activity';
export const CLICKED_ACTIVITY_FEED_LOAD_MORE =
  'Clicked Activity Feed Load More';

export const GIF_SETTINGS_UPDATE = 'Gif settings update';

// attachments
export const ATTACHMENT_CREATED = 'Attachment Created';
export const ATTACHMENT_OPENED = 'Attachment Opened';
export const ATTACHMENT_DELETED = 'Attachment Deleted';

// Share with Loom team Exp
export const SHARE_TEAM_EXP_HAS_REC_IDEA =
  'Share with Loom Team Has Recording Idea';
export const SHARE_TEAM_EXP_CHOICE = 'Share with Loom Team Exp Choice';
export const SHARE_TEAM_EXP_COMPLETE = 'Share with Loom Team Complete';

// new get started banner
export const GET_STARTED_BANNER_CTA_BUTTON_CLICK =
  'Get Started Banner Button CTA Click';

// search
// Fires when the search modal is opened
export const GLOBAL_SEARCH_OPENED = 'Global search opened';
// Fires when a search query is sent to the server
export const GLOBAL_SEARCH_QUERY_INITIATED = 'Global search query initiated';
// Fires when a search query's results are received on the client
export const GLOBAL_SEARCH_QUERIED = 'Global search queried';
// Fires when the user selects a search result from the list
export const GLOBAL_SEARCH_CLICKTHROUGH = 'Global search clickthrough';

// Contact
export const SHOW_CONTACT_SALES_FORM = 'Show Contact Sales form';
export const CONTACT_SALES_FORM_SUBMITTED = 'Contact Sales form submitted';
export const CONTACT_SUPPORT_FORM_SUBMITTED = 'Contact Support form submitted';

// Collborate
export const INVITE_TO_EDIT = 'Invite to Edit';
export const ORGANIZE_VIDEO = 'Organize Video';
export const CREATE_PUBLIC_LINK = 'Create Public Link';

export const WORKSPACE_DOWNGRADED_WITH_REASON =
  'Workspace Downgraded With Reason';

export const VISITED_NEW_TEAMS_DASHBOARD = 'Visited new teams dashboard';

export const INVITE_MEMBERS_LIBRARY_EMPTY_STATE =
  'Invite Members Library Empty State';

// Share with team CTA
export const CLICKED_SHARE_WITH_TEAM = 'Clicked Share with Team';
export const CLICKED_UNDO_SHARE_WITH_TEAM = 'Clicked Undo Share with Team';

// Internal Recovery Tool
export const RECOVERY_TOOL_CLICKED_RECOVER = 'Clicked Recover Video Button';
export const RECOVERY_TOOL_CLICKED_STATUS =
  'Clicked Recover Status Check Button';

// Video Uploads (user file uploads)
export const VIDEO_UPLOADS_UPLOAD_VIDEO_BUTTON_CLICKED =
  'Upload video modal button click';
export const VIDEO_UPLOADS_SHOW_MODAL_ON_PARAM_PAGE_LOAD =
  'Video upload shown on page load param';
export const VIDEO_UPLOADS_FILE_ADDED = 'Video Uploads file added';
export const VIDEO_UPLOADS_FILE_REMOVED = 'Video Uploads file removed';
export const VIDEO_UPLOADS_MODAL_CLOSED = 'Video Uploads modal closed';
export const VIDEO_UPLOADS_RESTRICTED_ERR = 'Video Uploads restricted error';
export const VIDEO_UPLOADS_UPLOADS_STARTED = 'Video Uploads uploads started';
export const VIDEO_UPLOADS_UPLOADED_TO_S3 = 'Video Uploads file uploaded to s3';
export const VIDEO_UPLOADS_BATCH_UPLOADED = 'Video Uploads batch uploaded';
export const VIDEO_UPLOADS_FILE_UPLOAD_FAILED =
  'Video Uploads file upload to s3 failed';
export const VIDEO_UPLOADS_UPLOAD_RETRIED = 'Video Uploads file upload retried';
export const VIDEO_UPLOADS_CANCEL_UPLOADS = 'Video Uploads cancel uploads';

export const EI_MODAL_VIEWS_OPEN = 'Insights Views Modal Open';
export const EI_SEE_ENGAGEMENTS_SHOWN = 'Engagement Insights CTA Box Shown';
export const EI_SEE_ENGAGEMENTS_CLICKED = 'Engagement Insights CTA Box Click';
export const EI_SEE_ENGAGEMENTS_CLOSED = 'Engagement Insights CTA Box Closed';
export const EI_PARTIAL_INFO_ACK = 'Engagement Insights Partial Info Box Ack';
export const EI_BACK_TO_LIST_CLICKED = 'Engagement Insights Back To List Click';
export const EI_VIEWER_DETAILS_CLICKED =
  'Engagement Insights Viewer Details Click';
export const EI_INFO_ICON_CLICKED = 'Engagement Insights Info Icon Click';
export const EI_INFO_LINK_CLICKED = 'Engagement Insights Info Link Click';

// Engagement Insights - Export CSV functionality
export const EI_EXPORT_FOLDER_BUTTON_CLICKED =
  'Export Insights button clicked from folder page';
export const EI_EXPORT_FOLDER_MODAL_LOADED =
  'Export Insights modal finished loading on folder page';
export const EI_EXPORT_FOLDER_MODAL_ERROR_LOADING =
  'Export Insights modal failed to load on folder page';
export const EI_EXPORT_FOLDER_MODAL_DOWNLOAD_CLICKED =
  'Export Insights CSV download started from modal on folder page';
export const EI_EXPORT_MANAGE_WORKSPACE_TAB_CLICKED =
  'Export Insights tab clicked on Manage Workspace page';
export const EI_EXPORT_MANAGE_WORKSPACE_TAB_LOADED =
  'Export Insights tab finished loading on Manage Workspace page';
export const EI_EXPORT_MANAGE_WORKSPACE_TAB_ERROR_LOADING =
  'Export Insights tab failed to load on Manage Workspace page';
export const EI_EXPORT_MANAGE_WORKSPACE_TAB_DOWNLOAD_CLICKED =
  'Export Insights CSV download started from Manage Workspace page';

export const INCLUDED_EVENTS_FROM_INTERCOM = [
  ONBOARDING_FLOW_STARTED,
  ONBOARDING_FLOW_COMPLETE,
];

export const ALLOWLIST_GOOGLE_ANALYTICS = [
  ONBOARDING_FLOW_COMPLETE,
  COMPLETED_ONBOARDING_STEP,
  USER_WORK_PERSONA_SELECTED,
];

export const ENGAGED_RBAC_RESTRICTION = 'Engaged RBAC restriction';

// Paywalls - P&P launch
export const SECURITY_TAB_SSO_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Security tab SSO in Manage Workspace page';
export const SECURITY_TAB_SCIM_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Security tab SCIM in Manage Workspace page';
export const APPEARANCE_TAB_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Appearance tab in Manage Workspace page';
export const EI_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Engagement tab in Manage Workspace page';
export const PRIVATE_CONTENT_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Private Content section in Manage Workspace page';
export const EXPORT_INSIGHTS_UPGRADE_BUTTON_CLICKED =
  'Export Insights upgrade button clicked';
export const ADD_CALL_TO_ACTION_UPGRADE_BUTTON_CLICKED =
  'Add Call-to-action upgrade button clicked';
export const ADD_THUMBNAIL_UPGRADE_BUTTON_CLICKED =
  'Upgrade thumbnail upgrade button clicked';
export const ADD_PASSWORD_UPGRADE_BUTTON_CLICKED =
  'Add Password upgrade button clicked';
export const SEE_ENGAGEMENT_UPGRADE_BUTTON_CLICKED =
  'See Engagement upgrade button clicked';
export const DATA_TAB_DATA_RETENTION_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Data tab Data Retention in Manage Workspace page';
export const DATA_TAB_AUDIT_LOG_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Data tab Audit Log in Manage Workspace page';
export const DATA_TAB_USER_REPORTS_UPGRADE_PILL_CLICKED =
  'Upgrade pill clicked from Data tab User Reports in Manage Workspace page';
export const HEADER_UPGRADE_TEXT_CLICKED = 'Upgrade text on header clicked';

export const EXPORT_AUDIT_LOG_CSV_CLICKED = 'Export audit log as CSV clicked';

export const CONTENT_LIMIT_MODAL_SHOWN = 'Content Limit Modal shown';
export const CONTENT_LIMIT_MODAL_CLICKED = 'Content Limit Modal clicked';
export const CONTENT_LIMIT_MODAL_DISMISSED = 'Content Limit Modal dismissed';
export const RECORDING_LIMIT_MODAL_SHOWN = 'Recording Limit Modal viewed';
export const RECORDING_LIMIT_MODAL_CLICKED = 'Recording Limit Modal clicked';
export const RECORDING_LIMIT_MODAL_DISMISSED =
  'Recording Limit Modal dismissed';
export const RECORDING_LIMIT_TOAST_CLICKED = 'Recording Limit toast clicked';
export const CONTENT_LIMIT_BANNER_CLICKED = 'Content Limit Banner Clicked';
export const APPROACHING_CONTENT_LIMIT_NOTIFICATION_CLICK =
  'Approaching Content Limit Notification Clicked';
export const REACHED_CONTENT_LIMIT_NOTIFICATION_CLICK =
  'Reached Content Limit Notification Clicked';

// Storage Incentives
export const STORAGE_INCENTIVE_INVITE_TEAMMATES_CTA_CLICKED =
  'Storage Incentive Invite Teammates CTA Clicked';
export const APPROACHING_CONTENT_LIMIT_UPGRADE_CLIKED =
  'Approaching Content Limit Banner Upgrade Clicked';
export const APPROACHING_CONTENT_LIMIT_BANNER_DISMISSED =
  'Approaching Content Limit Banner Dismissed';
export const APPROACHING_CONTENT_LIMIT_CHIP_DISMISSED =
  'Approaching Content Limit Chip Dismissed';
export const GLOBAL_CONTENT_LIMIT_BANNER_UPGRADE_CLICKED =
  'Global Content Limit Banner Upgrade Clicked';
export const STORAGE_INCENTIVE_TRACK_TAB_VIEWED =
  'Storage Incentive Track Tab Viewed';

export const DEBUG_PLAYBACK_RATE = 'Debug Playback Rate';

export const WATCH_LIST_ITEM_WATCH_CLICK = 'Watch List Item Watch Click';
export const WATCH_LIST_ITEM_REMOVE_CLICK = 'Watch List Item Remove Click';
export const WATCH_LIST_LOAD_MORE_CLICK = 'Watch List Load More Click';

// Invite teammate modal
export const TEAMMATE_INVITE_MODAL_DISPLAYED =
  'Teammate Invite Modal Displayed';
export const TEAMMATE_INVITE_MODAL_INVITE_SENT =
  'Teammate Invite Modal Invite Sent';

export const INVITE_MEMBERS_NAV_BUTTON_CLICKED =
  'Invite Members Nav Button Clicked';
export const INVITE_MEMBERS_WORKSPACE_SELECTOR_BUTTON_CLICKED =
  'Invite Members Workspace Selector Button Clicked';
export const MANAGE_WORKSPACE_MEMBERS_INVITE_MEMBER_CLICKED =
  'Manage Workspace Members Invite Member Clicked';

// SSO Security tab
export const SSO_ADD_DOMAIN_BUTTON_CLICKED = 'SSO Add Domain Button Clicked';
export const SSO_REMOVE_DOMAIN_BUTTON_CLICKED =
  'SSO Remove Domain Button Clicked';
export const SSO_PENDING_DOMAIN_ADDED = 'SSO Pending Domain Added';
export const SSO_DOMAIN_REMOVED = 'SSO Domain Removed';

// Transcription Events
export const TRANSCRIPTION_ACCESSED = 'Transcription Accessed';
export const TRANSCRIPTION_CLOSE_OUT = 'Transcription Close Out';
export const TRANSCRIPTION_NAVIGATED_BY_USER_SCROLL =
  'Transcription Navigated By User Scroll';
export const TRANSCRIPTION_NAVIGATED_BY_PHRASE_CLICK =
  'Transcription Navigated By Phrase Click';
export const TRANSCRIPTION_BACK_TO_ACTIVE_SCROLLING_CLICK =
  'Transcription Back To Active Scrolling Click';
export const TRANSCRIPTION_COPIED = 'Transcription Copied';
export const TRANSCRIPTION_SEARCH_OPENED = 'Transcription Search Opened';
export const TRANSCRIPTION_SEARCH_CLOSED = 'Transcription Search Closed';
export const TRANSCRIPTION_SEARCH_NAVIGATED = 'Transcription Search Navigated';
export const UPDATE_TRANSCRIPT_BY_FILLER_WORD_REMOVAL =
  'Transcript Updated By Filler Word Removal';
export const VIDEO_PLAYER_WILL_MUTE_FILLER_WORDS =
  'Video player played and will mute during filler words.';
export const FILLER_REMOVAL_DROPDOWN_CLOSE_OUT =
  'Filler Removal Dropdown Close Out';
export const DEFAULT_FILLER_REMOVAL_CLICK = 'Default Filler Removal Click';

// Transcription Correction
export const TRANSCRIPTION_CORRECTION_OPENED =
  'Transcription Correction Opened';
export const TRANSCRIPTION_CORRECTION_WORD_SELECTED =
  'Transcription Correction Word Selected';
export const TRANSCRIPTION_CORRECTION_CORRECT_SINGLE_WORD =
  'Transcription Correction Corrected Single Word';
export const TRANSCRIPTION_CORRECTION_CORRECT_ALL =
  'Transcription Correction Corrected All';
export const TRANSCRIPTION_CORRECTION_DELETE_WORD =
  'Transcription Correction Deleted Word';
export const TRANSCRIPTION_REVERT_ALL_CLICKED =
  'Transcription Correction Revert All Clicked';

// Captions Events
export const TOGGLE_CAPTIONS_ON = 'Toggle Captions ON';
export const TOGGLE_CAPTIONS_OFF = 'Toggle Captions OFF';
export const VIDEO_STARTED_WITH_CAPTIONS_ON = 'Video Started with Captions ON';
export const VIDEO_STARTED_WITH_CAPTIONS_OFF =
  'Video Started with Captions OFF';
export const CAPTIONS_DRAG_END = 'Captions dragged';

// External Recovery Tool
export const EXTERNAL_RECOVERY_TOOL_CLICKED_RECOVER =
  'User Clicked Recover Video Button';
export const EXTERNAL_RECOVERY_TOOL_CLICKED_STATUS =
  'User Clicked Recover Status Check Button';
export const EXTERNAL_RECOVERY_TOOL_ACCESSED =
  'User has accessed the external recovery tool page';
export const EXTERNAL_RECOVERY_TOOL_RECOVER_SUCCESS =
  'User received a video recovery success status';

// First Video Share Modal
export const FIRST_VIDEO_SHARE_MODAL_COPY_BUTTON_CLICKED =
  'First Video Share Modal Copy Button Clicked';
export const FIRST_VIDEO_SHARE_MODAL_RERECORD_BUTTON_CLICKED =
  'First Video Share Modal Re-record Button Clicked';
export const FIRST_VIDEO_SHARE_MODAL_COPY_BUTTON_DROPDOWN_CLICKED =
  'First Video Share Modal Copy Button Dropdown Clicked';

export const WORKSPACE_SUGGESTION_CLICK = 'Workspace Suggestion Click';

export const TOGGLE_AUTOJOIN_IN_MODAL_CALLOUT =
  'Toggle Autojoin in modal callout';

// Recorder download banner
export const DOWNLOAD_BANNER_EXTENSION_INSTALL_CLICKED =
  'Download Banner Extension Install Clicked';
export const DOWNLOAD_BANNER_DESKTOP_APP_INSTALL_CLICKED =
  'Download Banner Desktop App Install Clicked';

// Getting started checklist
export const GET_STARTED_CHECKLIST_SHOWN = 'Get Started Checklist Shown';
export const GET_STARTED_CHECKLIST_EXTENSION_INSTALL_CLICKED =
  'Get Started Checklist Extension Install Clicked';
export const GET_STARTED_CHECKLIST_DESKTOP_APP_INSTALL_CLICKED =
  'Get Started Checklist Desktop App Install Clicked';
export const GET_STARTED_CHECKLIST_MOBILE_APP_INSTALL_CLICKED =
  'Get Started Checklist Mobile App Install Clicked';
export const GET_STARTED_CHECKLIST_START_RECORDING_CLICKED =
  'Get Started Checklist Start Recording Clicked';
export const GET_STARTED_CHECKLIST_COPY_LINK_CLICKED =
  'Get Started Checklist Copy Link Clicked';
export const GET_STARTED_CHECKLIST_INVITE_TEAMMATE_CLICKED =
  'Get Started Checklist Invite Teammate Clicked';
export const GET_STARTED_CHECKLIST_EXPANDED = 'Get Started Checklist Expanded';
export const GET_STARTED_CHECKLIST_MINIMIZED =
  'Get Started Checklist Minimized';
export const GET_STARTED_CHECKLIST_RECORD_MODAL_DESKTOP_APP_INSTALL_CLICKED =
  'Get Started Checklist Record Modal Desktop App Install Clicked';
export const GET_STARTED_CHECKLIST_RECORD_MODAL_EXTENSION_INSTALL_CLICKED =
  'Get Started Checklist Record Modal Chrome Extension Install Clicked';
export const GET_STARTED_CHECKLIST_SHOULD_SHOW_MOBILE_NUDGE_EXPERIMENT =
  'Get Started Checklist Should Show Mobile Nudge Experiment';

// Security Tab events
export const SSO_UPDATED_FOR_WORKSPACE = 'SSO updated for workspace';
export const SCIM_UPDATED_FOR_WORKSPACE = 'SCIM updated for workspace';

// Video share page nav links
export const NAV_LINK_WAYS_TO_USE_LOOM_CLICKED =
  'Nav Link Ways To Use Loom Clicked';
export const NAV_LINK_ABOUT_US_CLICKED = 'Nav Link About Us Clicked';
export const NAV_LINK_PRICING_CLICKED = 'Nav Link Pricing Clicked';
export const ANON_NAV_SHOWN = 'Anon Nav Shown';
export const ANON_NAV_ITEM_CLICKED = 'Anon Nav Item Clicked';
export const ANON_NAV_LOGIN_PAGE_CLICKED = 'Anon Nav Login Page Clicked';
export const ANON_NAV_SIGNUP_PAGE_CLICKED = 'Anon Nav Signup Page Clicked';
export const ANON_EMPTY_STATE_SIGNUP_PAGE_CLICKED =
  'Anon Empty State Signup Page Clicked';

// Download video information modal
export const DOWNLOAD_INFO_MODAL_DOWNLOAD_CLICKED =
  'Download info modal download clicked';
export const DOWNLOAD_INFO_MODAL_COPY_LINK_CLICKED =
  'Download info modal copy link clicked';
export const DOWNLOAD_INFO_MODAL_EMBED_LINK_CLICKED =
  'Download info modal embed link clicked';

// Notification permissions
export const CLICKED_ALLOW_NOTIFICATIONS = 'Clicked Allow Notifications';
export const CLICKED_DISMISS_NOTIFICATIONS = 'Clicked Dismiss Notifications';
export const REQUEST_PERMISSIONS_RESULT = 'Request Permissions Result';
export const BLOCKED_NOTIFICATIONS_PROMPT_SHOWN =
  'Blocked Notifications Prompt Shown';
export const BLOCKED_NOTIFICATIONS_PROMPT_DISMISSED =
  'Blocked Notifications Prompt Dismissed';
export const WEB_PUSH_NOTIFICATION_CLICKED = 'Web Push Notification Clicked';

// Mobile banners
export const MOBILE_DOWNLOAD_BANNER_SHOWN = 'Mobile download banner shown';
export const MOBILE_DOWNLOAD_BANNER_DISMISSED =
  'Mobile download banner dismissed';
export const MOBILE_DOWNLOAD_BANNER_GET_APP_CLICKED =
  'Mobile download banner get app clicked';

export const CONTINUE_WATCHING_DOWNLOAD_TAPPED =
  'Continue Watching Download Tapped';

export const CONTINUE_WATCHING_SHOWN = 'Continue Watching Shown';
export const CONTINUE_WATCHING_DISMISSED = 'Continue Watching Dismissed';

// Shared with me
export const CLICKED_SHARED_WITH_ME_IN_SIDEBAR =
  'Click Shared With Me in Sidebar';
export const CLICKED_SHARED_WITH_ME_VIDEO = 'Click Shared With Me Video';
export const SHARED_WITH_ME_LOAD_MORE_CLICK = 'Click Shared With Me Load More';

// Share modal
export const SHARE_BUTTON_CLICKED = 'Share button clicked';
export const DATA_RETENTION_BANNER_PUBLISH_CLICKED =
  'Data retention banner publish clicked';
export const SHARE_MODAL_ACL_ADD = 'Share modal ACL add';
export const SHARE_MODAL_ADD_WITH_SOURCE = 'Share modal add with source';
export const SHARE_MODAL_PUBLIC_ACCESS_TOGGLED =
  'Share modal public access toggled';

// SDK
export const SDK_BROWSER_COMPATIBILITY_TEST_FAILED =
  'SDK browser compatibility test failed';
export const SDK_RECORD_BUTTON_CLICKED = 'SDK record button clicked';
export const SDK_RECORDING_CANCELED = 'SDK recording canceled';
export const SDK_RECORDING_COMPLETED = 'SDK recording completed';
export const SDK_UPLOAD_COMPLETED = 'SDK upload completed';
export const SDK_INSERT_BUTTON_CLICKED = 'SDK insert button clicked';

// Canvas
export const CANVAS_BACKGROUND_BUTTON_CLICKED =
  'Background button clicked on canvas';
export const CANVAS_BACKGROUND_MODAL_OPENED =
  'Background modal opened on canvas';
export const CANVAS_BACKGROUND_MODAL_CLOSED =
  'Background modal closed on canvas';
export const CANVAS_BACKGROUND_COLOR_SELECTED =
  'Background color selected on canvas';
export const CANVAS_BACKGROUND_IMAGE_SELECTED =
  'Background image selected on canvas';
export const CANVAS_BACKGROUND_COLOR_PICKER_OPENED =
  'Background color picker opened on canvas';
export const CANVAS_CUSTOM_BACKGROUND_COLOR_SELECTED =
  'Custom background color selected on canvas';
export const CANVAS_TEXT_LAYOUT_MODAL_OPENED =
  'Text layout modal opened on canvas';
export const CANVAS_TEXT_LAYOUT_MODAL_CLOSED =
  'Text layout modal closed on canvas';
export const CANVAS_TEXT_LAYOUT_SELECTED = 'Text layout selected on canvas';
export const CANVAS_TEXT_EDITOR_FORMAT_SELECTED =
  'Format selected on text editor toolbar on canvas';
export const CANVAS_TEMPLATES_MODAL_OPENED = 'Templates modal opened on canvas';
export const CANVAS_TEMPLATES_MODAL_CLOSED = 'Templates modal closed on canvas';
export const CANVAS_TEMPLATE_SELECTED = 'Template selected on canvas';

export const SLACK_RECORDER_STRATEGY_PICKED = 'Slack recorder strategy picked';

export const EXPERIMENT_ELIGIBILTY_PRECHECK_FAILED =
  'Experiment eligibility precheck failed';

// invite link
export const COPIED_INVITE_LINK = 'User copied invite link';
export const INVITE_LINK_COPY_FAILED = 'Failed to copy invite link';
export const INVITE_LINK_ERROR = 'Invite Link Error';

// Contact import
export const WORKSPACE_SETTINGS_INTEGRATION_PAGE_SEEN = 'Saw Integrations Page';
export const WORKSPACE_SETTINGS_INTEGRATION_CONNECT_DIALOG =
  'Saw Dialog Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_CONNECT_DISMISSED =
  'Dismissed Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_CONNECT_CLICKED =
  'Clicked Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_CONNECT_CONFIRMED =
  'Confirmed Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_INVITE_SEEN =
  'Seen Invite Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_INVITE_DISMISSED =
  'Dismissed Invite Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_INVITE_CONTINUE =
  'Clicked Continue Invite Integrations Page Connect';
export const WORKSPACE_SETTINGS_INTEGRATION_INVITE_LOADED =
  'Loaded Continue Invite Integrations Page Connect';
export const IMPORT_CONTACTS_ENTRYPOINT_SEEN =
  'Import Contacts Entrypoint Seen';
export const INVITE_CONTACTS_ENTRYPOINT_SEEN =
  'Invite Contacts Entrypoint Seen';
export const IMPORT_CONTACTS_ENTRYPOINT_CLICKED =
  'Import Contacts Entrypoint Clicked';
export const INVITE_CONTACTS_ENTRYPOINT_CLICKED =
  'Invite Contacts Entrypoint Clicked';

// Waveform
export const WAVEFORM_ACTIVE_USER =
  'Consider active user for wavefrom experiment';
// Visibility
export const VIDEO_PUBLISH_TOGGLED = 'video_publish_toggled';
export const BULK_VIDEO_PUBLISH_TOGGLED = 'bulk_video_publish_toggled';
export const FOLDER_PUBLISH_TOGGLED = 'folder_publish_toggled';
export const BULK_FOLDER_PUBLISH_TOGGLED = 'bulk_folder_publish_toggled';

// Default Workspace
export const DEFAULT_WORKSPACE_UPDATED_BANNER_RENDERED =
  'Default Workspace Updated Banner Rendered';
export const DEFAULT_WORKSPACE_UPDATED_BANNER_PERSONAL_SETTINGS_CLICKED =
  'Default Workspace Updated Banner Personal Setting Clicked';
export const DEFAULT_WORKSPACE_ONBOARDING_MODAL_RENDERED =
  'Default Workspace Onboarding Modal Rendered';
export const DEFAULT_WORKSPACE_ONBOARDING_MODAL_MIGRATE_CLICKED =
  'Default Workspace Onboarding Modal Migrate Clicked';
export const DEFAULT_WORKSPACE_ONBOARDING_MODAL_PERSONAL_LIBRARY_CLICKED =
  'Default Workspace Onboarding Modal Personal Library Clicked';
export const DEFAULT_WORKSPACE_ONBOARDING_MODAL_CLOSED =
  'Default Workspace Onboarding Modal Closed';

// Follows
export const TAG_FOLLOWED = 'tag_followed';
export const TAG_UNFOLLOWED = 'tag_unfollowed';
export const TAG_FOLLOW_SUGGESTION_DISPOSITIONED =
  'tag_follow_suggestion_dispositioned';
export const PROFILE_FOLLOWED = 'profile_followed';
export const PROFILE_UNFOLLOWED = 'profile_unfollowed';
export const PROFILE_FOLLOW_SUGGESTION_DISPOSITIONED =
  'profile_follow_suggestion_dispositioned';

// Profiles
export const PROFILE_HOVERED = 'profile_hovered';
export const PROFILE_INFORMATION_SAVED = 'profile_information_saved';
export const PROFILE_VIDEO_PINNED = 'profile_video_pinned';
export const PROFILE_VIDEO_UNPINNED = 'profile_video_unpinned';

// Workspace Groups
export const WORKSPACE_SETTINGS_GROUPS_PAGE_SEEN =
  'Workspace Settings Groups Page Seen';
export const CREATE_GROUP_MODAL_SEEN = 'Create Group Workspace Modal Seen';
export const CREATE_GROUP_MODAL_DISMISSED =
  'Create Group Workspace Modal Dismissed';
export const CREATE_GROUP_MODAL_SAVED = 'Create Group Workspace Modal Saved';
export const UPDATE_GROUP_MODAL_SEEN = 'Update Group Workspace Modal Seen';
export const UPDATE_GROUP_MODAL_DISMISSED =
  'Update Group Workspace Modal Dismissed';
export const UPDATE_GROUP_MODAL_SAVED = 'Update Group Workspace Modal Saved';
export const REMOVE_GROUP_MODAL_SEEN = 'Remove Group Workspace Modal Seen';
export const REMOVE_GROUP_MODAL_DISMISSED =
  'Remove Group Workspace Modal Dismissed';
export const REMOVE_GROUP_MODAL_SAVED = 'Remove Group Workspace Modal Saved';
export const GROUPS_MANAGEMENT_TABLE_SORTED = 'Groups Management Table Sorted';
export const VIEW_ALL_MEMBERS_CLICKED = 'View All Members Clicked';
export const GROUPS_MANAGEMENT_TABLE_ROW_SELECTED =
  'Groups Management Table Row Selected';
export const EXEMPT_GROUP_MODAL_SEEN = 'Exempt Workspace Group Modal Seen';
export const EXEMPT_GROUP_MODAL_DISMISSED =
  'Exempt Workspace Group Modal Dismissed';
export const EXEMPT_GROUP_MODAL_UPDATED =
  'Exempt Workspace Group Modal Updated';

// Workspace Members
export const WORKSPACE_SETTINGS_MEMBERS_PAGE_SEEN =
  'Workspace Settings Members Page Seen';
export const MEMBERS_MANAGEMENT_UPDATE_MEMBER_ROLE =
  'Member Management Update Member Role';
export const MEMBERS_MANAGEMENT_REMOVE_MEMBER =
  'Members Management Remove Member';
export const MEMBERS_MANAGEMENT_TABLE_SORTED =
  'Members Management Table Sorted';
export const MEMBERS_MANAGEMENT_TABLE_ROW_SELECTED =
  'Members Management Table Row Selected';

// Workspace Content Settings
export const CONTENT_PRIVACY_UPDATE_CANCELLED =
  'Workspace Content Privacy Update Cancelled';
export const CONTENT_PRIVACY_UPDATE_SAVED =
  'Workspace Content Privacy Update Saved';

// Workspace User Reports
export const USER_REPORTS_DOWNLOAD_CLICKED =
  'Workspace User Reports Download Clicked';

// FTUX
export const FTUX_TOOLTIP_RENDERED = 'ftux_tooltip_rendered';
export const FTUX_TOOLTIP_DISMISSED = 'ftux_tooltip_dismissed';
export const FTUX_TOOLTIP_SHARE_VIDEO_ADD_TAG =
  'ftux_tooltip_share_video_add_tag';
export const GOOGLE_CONTACT_IMPORT_INTEGRATIONS_FTUX =
  'google_contact_import_integrations_ftux';
export const NOTIFICATION_TRANSCRIPT_FTUX = 'notification_transcript_ftux';

// Persistent Record button events
export const RECORD_BUTTON_CLICKED = 'Record button clicked';
export const RECORDER_INITIATED = 'Recorder Initiated';
export const PERSISTENT_RECORD_NO_RECORDER_FALLBACK_SHOWN =
  'No Recorder Fallback Modal Shown';

// Weave
export const EDIT_CANCEL_CHANGE = 'Edit - Cancel Change';
export const EDIT_CLICK_ADD_CLIP = 'Edit - Click Add Clip';
export const EDIT_CLICK_REDO = 'Edit - Click Redo';
export const EDIT_CLICK_SPLIT_AT = 'Edit - Click Split At';
export const EDIT_CLICK_UNDO = 'Edit - Click Undo';
export const EDIT_DELETE_ADD_CLIP = 'Edit - Delete Add Clip';
export const EDIT_DELETE_TRIMMED_CLIP = 'Edit - Delete Trimmed Clip';
export const EDIT_NEW_CLIP_ADDED = 'Edit - New Clip Added';
export const EDIT_REVERT_TO_ORIGINAL = 'Edit - Revert to Original';
export const EDIT_SAVE_CHANGE = 'Edit - Save Change';
export const EDIT_SEARCH_ADD_CLIP = 'Edit - Search Add Clip';
export const EDIT_UPDATE_TIME_RANGE = 'Edit - Update Time Range';
export const ENTER_EDIT_MODE = 'Enter Edit Mode';
export const REPOSITION_CLIPS = 'Edit - reposition clips';

// Heuristic tags
export const HEURISTIC_TAG_DROPDOWN_SHOWN = 'heuristic_tag_dropdown_shown';
export const HEURISTIC_TAG_DROPDOWN_SELECTED =
  'heuristic_tag_dropdown_selected';

// Autogenerated video suggested tags
export const VIDEO_TAG_SUGGESTION_DISPOSITIONED =
  'tag_suggestion_dispositioned';
export const VIDEO_TAG_SUGGESTION_SHOWN = 'tag_suggestion_shown';

// Standardized Invite Steps
export const INVITE_TEAMMATES_CLICKED = 'invite_teammates_clicked';
export const INVITE_TEAMMATES_MODAL_DISPLAYED = 'invite_modal_displayed';
export const INVITE_EMAIL_ADDED = 'invite_email_added';

// Meetings Synced Videos
export const SYNCED_VIDEOS_PAGE_SEEN = 'synced_videos_page_seen';
export const SYNCED_VIDEOS_PAGE_MEETINGS_LOADED =
  'synced_videos_page_meetings_loaded';
export const SYNCED_VIDEOS_MEETING_SETTINGS_MODAL_SEEN =
  'synced_videos_meetings_settings_modal_seen';
export const SYNCED_VIDEOS_MEETING_SETTINGS_MODAL_DISMISSED =
  'synced_videos_meetings_settings_modal_dismissed';
export const SYNCED_VIDEOS_MEETING_SETTINGS_MODAL_UPDATE_CLICKED =
  'synced_videos_meetings_settings_modal_update_clicked';
export const SYNCED_VIDEOS_MEETING_AUTO_RECORD_UPDATED =
  'synced_videos_meeting_auto_record_updated';
export const SYNCED_VIDEOS_MEETING_VISIBILITY_UPDATED =
  'synced_videos_meeting_visibility_updated';
export const SYNCED_VIDEOS_IMPORT_RECORDINGS_MODAL_SEEN =
  'synced_videos_import_recordings_modal_seen';
export const SYNCED_VIDEOS_IMPORT_RECORDINGS_MODAL_LOADED =
  'synced_videos_import_recordings_modal_loaded';
export const SYNCED_VIDEOS_IMPORT_RECORDINGS_MODAL_DISMISSED =
  'synced_videos_import_recordings_modal_dismissed';
export const SYNCED_VIDEOS_IMPORT_RECORDINGS_MODAL_IMPORT_CLICKED =
  'synced_videos_import_recordings_modal_import_clicked';
export const INGESTION_ENABLED_NOTIFICATION_SYNCED_MEETINGS_CLICKED =
  'ingestion_enabled_notification_synced_meetings_clicked';

// ZOOM Integration
export const ZOOM_INTEGRATION_CLICKED = 'Zoom Integration Clicked';
export const ZOOM_INTEGRATION_MODAL_CONTINUE_CLICKED =
  'Zoom Integration Modal Continue Clicked';
export const ZOOM_INTEGRATION_MODAL_DISMISSED =
  'Zoom Integration Modal Dismissed';
export const ZOOM_INTEGRATION_USER_DEFAULT_UPDATED =
  'Zoom Integration User Default Updated';
export const ZOOM_INTEGRATION_CONTENT_DEFAULT_UPDATED =
  'Zoom Integration Content Default Updated';
export const ZOOM_INTEGRATION_CONTENT_DEFAULT_CANCELED =
  'Zoom Integration Content Default Canceled';

// Notifications Page
export const NOTIFICATION_TRANSCRIPT_EXPANDED =
  'website.notification_transcript_expanded';
export const NOTIFICATION_TRANSCRIPT_COLLAPSED =
  'website.notification_transcript_collapsed';
export const NOTIFICATION_SETTING_TOGGLED = 'notifications_setting_toggled';
export const NOTIFICATION_MINI_PLAYER_CLICKED =
  'notification_mini_player_clicked';

// Sidebar
export const SIDEBAR_FOLLOWED_TAG_CLICKED = 'sidebar_followed_tag_clicked';
export const SIDEBAR_FOLLOWED_PROFILE_CLICKED =
  'sidebar_followed_profile_clicked';

// Filtering
export const LOOMS_PAGE_FILTERED = 'looms_page_filtered';

// Join workspace from share page
export const JOIN_WORKSPACE_BANNER_CLICKED = 'join-workspace-banner-clicked';
export const JOIN_WORKSPACE_BANNER_DISMISSED =
  'join-workspace-banner-dismissed';

// End of video signup nudge
export const END_OF_VIDEO_EMAIL_SIGNUP_FORM_CLICKED =
  'End of Video Email Signup Form Clicked';

// Home
export const HOME_FEED_RENDERED = 'home_feed_rendered';
export const SHOW_MORE_VIDEOS_BUTTON_CLICKED =
  'show_more_videos_button_clicked';
export const VIDEO_CARD_CLICKED = 'video_card_clicked';
